const muiTableHeadCellProps = ({ column, columnIndex, table }) => ({
  sx: {
    fontSize: "14px",
    backgroundColor: "#F5F8FA",
    border: "none",
    borderBottom: "none",
    boxShadow: "none",
    height: "30px",
    padding: "8px 16px",
    ...(columnIndex === 0 && {
      borderTopLeftRadius: "8px",
      borderBottomLeftRadius: "8px",
      paddingLeft: "8px",
    }),
    ...(columnIndex === table.getAllColumns().length - 1 && {
      borderTopRightRadius: "8px",
      borderBottomRightRadius: "8px",
      paddingRight: "8px",
    }),
    ...(column.id === "mrt-row-select" && {
      backgroundColor: "#F5F8FA",
      textAlign: "center",
      padding: "8px",
      boxShadow: "none",
    }),
  },
});

const generateColumnTable = (accessorKey, header) => {
  return {
    accessorKey,
    header,
    muiTableHeadCellProps,
    muiTableBodyCellProps: { 
      sx: { 
        fontSize: "12px",
        padding: "8px 16px",
        "&:first-of-type": {
          paddingLeft: "8px",
        },
        "&:last-of-type": {
          paddingRight: "8px",
        }
      } 
    },
  };
};

const defaultTableConfig = {
  manualPagination: true,
  manualSorting: true,
  manualGlobalFilter: true,
  enableRowSelection: true,
  enableSorting: false,
  enableColumnFilters: false,
  showGlobalFilter: false,
  enableHiding: true,
  enableColumnActions: false,
  enableColumnResizing: false,
  enableFullScreenToggle: true,
  enableDensityToggle: true,
  enableTopToolbar: false,
  enableStickyHeader: true,
  enablePagination: true,
  muiTableHeadCellProps: ({ column, columnIndex, table }) => ({
    sx: {
      fontSize: "14px",
      backgroundColor: "#F5F8FA",
      border: "none",
      borderBottom: "none",
      boxShadow: "none",
      height: "30px",
      padding: "8px 16px",
      ...(columnIndex === 0 && {
        borderTopLeftRadius: "8px",
        borderBottomLeftRadius: "8px",
        paddingLeft: "8px",
      }),
      ...(columnIndex === table.getAllColumns().length - 1 && {
        borderTopRightRadius: "8px",
        borderBottomRightRadius: "8px",
        paddingRight: "8px",
      }),
      ...(column.id === "mrt-row-select" && {
        backgroundColor: "#F5F8FA",
        textAlign: "center",
        padding: "8px",
        boxShadow: "none",
      }),
    },
  }),
  muiTableHeadProps: {
    sx: {
      backgroundColor: "#F5F8FA",
      border: "none",
      boxShadow: "none",
      "& tr": {
        boxShadow: "none !important",
      },
      "& th": {
        boxShadow: "none !important",
      },
    },
  },
  muiTableBodyCellProps: ({ column, columnIndex, table }) => ({
    sx: {
      "&:hover": {
        backgroundColor: "#f5f5f5",
      },
      borderBottom: "1px solid #E0E0E0",
      padding: "8px 16px",
      ...(columnIndex === 0 && {
        borderBottomLeftRadius: "8px",
        paddingLeft: "8px",
      }),
      ...(columnIndex === table.getAllColumns().length - 1 && {
        borderBottomRightRadius: "8px",
        paddingRight: "8px",
      }),
      ...(column?.id === "mrt-row-select" && {
        borderBottom: "1px solid #E0E0E0",
        padding: "8px",
      })
    },
  }),
  muiTableBodyProps: {
    sx: {
      "& tr:last-child td": {
        borderBottom: "1px solid #E0E0E0 !important"
      },
      "& tr td": {
        borderBottom: "1px solid #E0E0E0"
      }
    }
  },
  muiTableContainerProps: {
    sx: {
      borderBottom: "1px solid #E0E0E0",
      height: "calc(100vh - 200px)",
    },
  },
  muiTablePaperProps: {
    sx: {
      boxShadow: "none",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      "& .MuiTableContainer-root": {
        "& table": {
          "& thead": {
            "& tr": {
              "& th:first-of-type": {
                borderTopLeftRadius: "8px",
                borderBottomLeftRadius: "8px",
              },
              "& th:last-of-type": {
                borderTopRightRadius: "8px",
                borderBottomRightRadius: "8px",
              }
            }
          },
          "& tbody": {
            "& tr:last-child": {
              "& td:first-of-type": {
                borderBottomLeftRadius: "8px",
              },
              "& td:last-of-type": {
                borderBottomRightRadius: "8px",
              }
            },
            "& tr td": {
              borderBottom: "1px solid #E0E0E0",
            }
          }
        }
      }
    },
  },
  muiTopToolbarProps: false,
  enableGlobalFilter: true,
};

export { generateColumnTable, muiTableHeadCellProps, defaultTableConfig };
